import React from "react";
import {
  Dialog,
  DialogContent,
  Box,
  Typography,
  IconButton,
} from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CloseIcon from "@mui/icons-material/Close";

const SuccessModal = ({ open, onClose, title = "Success!", message, icon }) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 2,
          bgcolor: "#001b2b",
          color: "white",
        },
      }}
    >
      <IconButton
        onClick={onClose}
        sx={{
          position: "absolute",
          right: 8,
          top: 8,
          color: "white",
        }}
      >
        <CloseIcon />
      </IconButton>
      <DialogContent>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            py: 4,
          }}
        >
          {icon || (
            <CheckCircleIcon
              sx={{
                fontSize: 80,
                color: "#4caf50",
                mb: 2,
              }}
            />
          )}
          <Typography
            variant="h5"
            sx={{
              fontFamily: "Lato",
              fontWeight: "bold",
              mb: 2,
              color: "white",
            }}
          >
            {title}
          </Typography>
          {message && (
            <Typography
              variant="body1"
              sx={{
                fontFamily: "Lato",
                textAlign: "center",
                color: "white",
              }}
            >
              {message}
            </Typography>
          )}
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default SuccessModal;
